module.exports = __webpack_public_path__ + "img/upload.bd273a9b.gif";